var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.25 93.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;}.cls-1,.cls-2{fill:none;stroke:#1e3e80;stroke-width:2.97px;}.cls-3{fill:#1e3e80;}.cls-4{fill:#59ac31;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.87,72.31c-8.3,0-15.91-2.99-19.87-7.8-.77-.93-.63-2.31,.3-3.08,.93-.77,2.31-.63,3.08,.3,3.1,3.77,9.57,6.21,16.49,6.21s13.15-2.31,16.34-6.03c.79-.92,2.17-1.03,3.09-.23,.92,.79,1.02,2.17,.24,3.09-4,4.66-11.54,7.56-19.66,7.56Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.4,
    y1: 44.39,
    x2: 90.74,
    y2: 33.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.96,
    y1: 43.23,
    x2: 8.17,
    y2: 36.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.25,23.76c.16,.64-.11,1.33-.71,1.67-.72,.41-1.64,.17-2.05-.55C74.82,8.05,54.91-.41,36.06,4.3,12.72,10.14-1.52,33.88,4.32,57.22c5.84,23.34,29.58,37.58,52.92,31.74,18.5-4.63,32.07-21.15,33-40.18,.04-.83,.75-1.47,1.58-1.43,.83,.04,1.47,.73,1.43,1.58-.99,20.34-15.5,38.01-35.27,42.95C33.02,98.12,7.64,82.91,1.4,57.96-4.84,33.01,10.38,7.63,35.33,1.38c20.15-5.04,41.44,4,51.77,22,.07,.12,.12,.25,.16,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.39,44.59c0,2.23-1.81,4.04-4.04,4.04s-4.03-1.81-4.03-4.04,1.81-4.03,4.03-4.03,4.04,1.81,4.04,4.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.05,44.59c0,2.23-1.81,4.04-4.04,4.04s-4.03-1.81-4.03-4.04,1.81-4.03,4.03-4.03,4.04,1.81,4.04,4.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.36,
    cy: 44.29,
    r: 10.14,
    transform: "translate(-21.56 56.31) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.32,
    y1: 44.18,
    x2: 51.93,
    y2: 44.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.94,
    cy: 43.85,
    r: 10.14,
    transform: "translate(-2.89 83.37) rotate(-67.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/Glasses.a5342554752e1a98d52ae8a3711e0d93.svg";
export { ForwardRef as ReactComponent };